import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=be8c7798&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be8c7798')) {
      api.createRecord('be8c7798', component.options)
    } else {
      api.reload('be8c7798', component.options)
    }
    module.hot.accept("./ClientPage.vue?vue&type=template&id=be8c7798&", function () {
      api.rerender('be8c7798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientPage.vue"
export default component.exports